var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:['btn', `col-${_vm.btnColor}`, `fcol-${_vm.btnFontColor}`, `sz-${_vm.btnSize}`],attrs:{"disabled":_vm.disabled,"type":_vm.type}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }